import React from 'react'
import './style.scss'
import { FiX } from 'react-icons/fi'

function ButtonFechar({ onClick }) {
    return (
        <div onClick={onClick} className={`button button-close`}>
            <FiX />
        </div>
    )
}

export default ButtonFechar